

import { IeLynxObject } from "../../common/models/eLynxObject";
import { DialogResult, DialogState, BindDialogReturn, useDialogState, bindDialog, DialogProps } from "../../hooks/use-dialog-state/UseDialogState";
import FullScreenDialog, { FullScreenDialogCloseReason } from "../full-screen-dialog/FullScreenDialog";
import AttributeSchemaEditor from "./AttributeSchemaEditor";

import type { JSX } from "react";

export type AttributeSchemaEditorDialogInitValues = {
    organizationID: number;    
    groupID: number;
    attributeSchemaID: number;
    attributeSchemaName: string;
    targetObject?: IeLynxObject;
};

export type AttributeSchemaEditorDialogResultValues = {
    attributeSchemaID: number;
};

export type AttributeSchemaEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type AttributeSchemaEditorDialogResult = DialogResult<AttributeSchemaEditorDialogResultValues, AttributeSchemaEditorDialogResultReason>;

export type AttributeSchemaEditorDialogProps = DialogProps<AttributeSchemaEditorDialogInitValues, AttributeSchemaEditorDialogResult>;

export default function AttributeSchemaEditorDialog({
    open,
    onClose,
    values
}: AttributeSchemaEditorDialogProps): JSX.Element {

    return (
        
        values ?
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <AttributeSchemaEditor
                organizationID={values.organizationID}
                groupID={values.groupID}
                targetObject={values.targetObject}
                attributeSchemaID={values.attributeSchemaID }
                attributeSchemaName={values.attributeSchemaName}
                onClose={({
                    reason, 
                    attributeSchemaID
                }) => onClose({
                    reason: reason,
                    values: {
                        attributeSchemaID: attributeSchemaID ?? values?.attributeSchemaID
                    }
                })}
            />
        </FullScreenDialog>
        : <></>
    );
}

export type AttributeSchemaEditorDialogState = DialogState<AttributeSchemaEditorDialogInitValues, AttributeSchemaEditorDialogResult>;
export type BindAttributeSchemaEditorDialogReturn = BindDialogReturn<AttributeSchemaEditorDialogInitValues, AttributeSchemaEditorDialogResult>;

export function useAttributeSchemaEditorDialogState(): AttributeSchemaEditorDialogState {
    return useDialogState();
}

export function bindAttributeSchemaEditorDialog(props: AttributeSchemaEditorDialogState): BindAttributeSchemaEditorDialogReturn {
    return bindDialog(props);
}
